const MESES_CURTOS = [
  'jan',
  'fev',
  'mar',
  'abr',
  'mai',
  'jun',
  'jul',
  'ago',
  'set',
  'out',
  'nov',
  'dez',
];

const MESES_LONGOS = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

const UM_DIA_MS = 86_400_000;

export const REFERENCIA_HOJE_ISO = '2026-06-01';

const referenciaHoje = () => new Date();

// Aceita tanto ISO completo do backend (`2026-08-15T21:00:00.000Z`) quanto data
// "só dia" (`2026-08-15`, do mock, ancorada ao meio-dia local). Data inválida → null.
const parseData = (iso: string | null): Date | null => {
  if (!iso) return null;
  const data = iso.includes('T') ? new Date(iso) : new Date(`${iso}T12:00:00`);
  return Number.isNaN(data.getTime()) ? null : data;
};

export const formatarData = (iso: string | null): string => {
  const data = parseData(iso);
  if (!data) return '—';
  return `${String(data.getDate()).padStart(2, '0')} ${MESES_CURTOS[data.getMonth()]}`;
};

export const formatarDataLonga = (iso: string | null): string => {
  const data = parseData(iso);
  if (!data) return '—';
  return `${String(data.getDate()).padStart(2, '0')} de ${MESES_LONGOS[data.getMonth()]} de ${data.getFullYear()}`;
};

export const formatarHora = (iso: string | null): string => {
  const data = parseData(iso);
  if (!data) return '—';
  return `${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}`;
};

export const adicionarDias = (iso: string, dias: number): string => {
  const data = parseData(iso);
  if (!data) return iso;
  data.setDate(data.getDate() + dias);
  return data.toISOString().slice(0, 10);
};

export const adicionarDiasUteis = (iso: string, dias: number): string => {
  const data = parseData(iso);
  if (!data) return iso;
  let restantes = dias;
  while (restantes > 0) {
    data.setDate(data.getDate() + 1);
    const diaSemana = data.getDay();
    if (diaSemana !== 0 && diaSemana !== 6) {
      restantes -= 1;
    }
  }
  return data.toISOString().slice(0, 10);
};

export const tempoRelativo = (iso: string | null): string => {
  const data = parseData(iso);
  if (!data) return '—';
  const diferenca = Math.round((referenciaHoje().getTime() - data.getTime()) / UM_DIA_MS);
  if (diferenca <= 0) return 'hoje';
  if (diferenca === 1) return 'ontem';
  if (diferenca < 7) return `há ${diferenca} dias`;
  if (diferenca < 30) return `há ${Math.floor(diferenca / 7)} sem`;
  return formatarData(iso);
};
